import React, { useRef, useState } from 'react';
import { translate } from "../Services/translation";

const SelectOrganizationForm = ({
  antiForgeryToken,
  isUserCustomerServiceString,
  redirectUrl,
  organizationsString,
}) => {
  const organizations = JSON.parse(organizationsString);
  const isUserCustomerService = /true/gi.test(isUserCustomerServiceString);
  const formEl = useRef(null);
  const [customerServiceSelectedOrganizationId, setCustomerServiceSelectedOrganizationId] = useState("");
  
  const onChange = (displayNameInput) => {
    let selectedOrg = organizations.find(e => e.displayName === displayNameInput)
    if(selectedOrg){
      setCustomerServiceSelectedOrganizationId(selectedOrg.organizationId)
    }
    else {
      setCustomerServiceSelectedOrganizationId("")
    }
  }
  
  const onSubmit = (ev) => {
    ev.preventDefault();
    if (isUserCustomerService) {
      if (customerServiceSelectedOrganizationId !== "") {
        formEl.current.submit();
      }
    } else {
      formEl.current.submit();
    }
  };
  return (
    <form onSubmit={onSubmit} method="post" ref={formEl}>
      <fieldset className="form">
        <div>
          <input
            id="RedirectUrl"
            name="RedirectUrl"
            type="hidden"
            value={redirectUrl}
          />
          <input
            name="__RequestVerificationToken"
            type="hidden"
            value={antiForgeryToken}
          />
          <label className="form__label" htmlFor="SelectedOrganization">
            {translate('selectorganization.selectorganization')}
          </label>
          {isUserCustomerService && (
            <>
              <input
                onChange={(ev) => onChange(ev.target.value)}
                className="form__input"
                list="org"
                name="selectedOrganizationId"
              />
              <input
                  type="hidden"
                  name="customerServiceSelectedOrganization.OrganizationId"
                  value={customerServiceSelectedOrganizationId}/>
              <datalist id="org">
                {organizations.map((x) => (
                  <option value={x.displayName} key={x.organizationSystemId} />
                ))}
              </datalist>
            </>
          )}
          {!isUserCustomerService && (
            <select
              className="form__input"
              required
              id="SelectedOrganization"
              name="SelectedOrganization"
            >
              {organizations.map((x) => (
                <option value={x.organizationSystemId} key={x.organizationSystemId}>
                  {x.displayName}
                </option>
              ))}
            </select>
          )}
        </div>
        <input
          type="submit"
          className="form__button form__button--expand"
          value={translate('selectorganization.send')}
        />
      </fieldset>
    </form>
  );
};
export default SelectOrganizationForm;